//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../no/ugmath.js";
import "../no/Diagramming.js";
let d=[[[0,"DisplayDigit",1,0],[0,"LinesPerLadder",1,0],[0,"NumberOfLadders",1,0],[0,"StartValueLadder1",1,0],[0,"StartValueLadder2",1,0]],[[["point"],"SetLadderStartLocation",{},1,0],[["table"],"MakeLadderDataTable",{},1,0]],[]];
SPLM.AME.LadderDataBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.LadderDataBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.LadderDataBuilder.Ladders = Object.freeze({
    "One" : "One", "Two" : "Two"});

export default SPLM;